<template>
  <div
    :id="container"
    @mousemove="updateMousePosition"
    @mouseleave="removeMouseAction"
    @mouseenter="addMouseAction"
    @touchstart="addMouseAction"
    @touchmove="updateMousePosition"
    @touchend="removeMouseAction"
  >
    <!-- todo add mobile touch -->
    <chart-graphics
      :container="container"
      :mousePosition="dataLabelPosition"
      :chartData="chartData"
    />
    <div
      v-if="dataLabelVisible"
      class="data-labels"
      id="simple-city-software-charts-data-label-container"
    >
      <div class="label-title">
        <h5>{{ chartData[0].labels[hoveredIndex] }}</h5>
      </div>
      <chart-data-labels
        v-for="(series, index) in chartData"
        :key="index"
        :label="series.title"
        :labelData="formatData(series.data[hoveredIndex])"
        left="125px"
        :color="series.color"
      />
    </div>
  </div>
</template>

<script>
import ChartDataLabels from "./ChartDataLabels.vue";
import ChartGraphics from "./ChartGraphics.vue";
export default {
  data() {
    return {
      hoveredIndex: 0,
      dataLabelSide: "left",
      dataLabelPosition: 0,
      dataLabelVisible: false,
    };
  },
  computed: {
    width() {
      let container = document.getElementById(this.container);
      return getComputedStyle(container).getPropertyValue("width").slice(0, -2);
    },
    height() {
      let container = document.getElementById(this.container);
      return getComputedStyle(container)
        .getPropertyValue("height")
        .slice(0, -2);
    },
    dataLabelContainerWidth() {
      let element = document.getElementById(
        "simple-city-software-charts-data-label-container"
      );
      return getComputedStyle(element).getPropertyValue("width").slice(0, -2);
    },
    snapPoints() {
      let sectionWidth = this.width / this.chartData[0].data.length + 1;
      return this.chartData[0].data.map((_element, index) => {
        return index * sectionWidth;
      });
    },
  },
  methods: {
    findClosestNumber(target) {
      let match = null;
      this.snapPoints.forEach((element) => {
        let targetDiff = Math.abs(element - target);
        let matchDiff = Math.abs(match - target);
        if (match === null) {
          match = element;
          return;
        } else if (matchDiff > targetDiff) {
          match = element;
          return;
        } else if (target < (this.snapPoints[1] - this.snapPoints[0]) / 2) {
          match = 5;
          return;
        } else {
          return;
        }
      });
      return match;
    },
    addMouseAction() {
      this.dataLabelVisible = true;
    },
    updateMousePosition(e) {
      let rect = e.target.getBoundingClientRect();
      if (rect.right - e.clientX < this.dataLabelContainerWidth + 30) {
        this.dataLabelSide = "right";
        this.dataLabelPosition = this.findClosestNumber(rect.right - e.clientX);
      } else {
        this.dataLabelSide = "left";
        this.dataLabelPosition = this.findClosestNumber(e.clientX - rect.left);
      }
      this.hoveredIndex = this.snapPoints.indexOf(
        this.findClosestNumber(e.clientX - rect.left) !== 5
          ? this.findClosestNumber(e.clientX - rect.left)
          : 0
      );
    },
    removeMouseAction() {
      this.dataLabelVisible = false;
    },
    formatData(data) {
      if (this.formatter) {
        return this.formatter(data);
      } else {
        return data.toLocaleString("lookup", {
          style: "currency",
          currency: this.$store.getters.currencyCode,
        });
      }
    },
  },
  props: ["container", "formatter", "chartData"],
  components: { ChartDataLabels, ChartGraphics },
};
</script>

<style>
div {
  position: relative;
}

.data-labels {
  position: absolute;
  height: 100%;
  pointer-events: none;
  transition: all 0.25s ease-in-out;
  left: 20px;
}

path {
  pointer-events: none;
}
</style>
